export default {
  'Resolution': 'Resolutie',
  'Frame rate': 'Beeldsnelheid',
  'The higher the frame rate, the smoother the animation': 'Hoe hoger de framerate, hoe vloeiender de animatie.',
}